// Form validation for Holiday form
import { dropdownValidator, plaintextValidator } from '../fields';

const config = {};

export default {
  name: plaintextValidator({ mandatory: true }),
  year: dropdownValidator({
    mandatory: true,
    customError: 'Year must be selected'
  }),
  // holidays: multiselectValidator(config),
  holidays: {
    array: {
      name: {
        presence: {
          allowEmpty: false,
          message: '^Description cannot be empty'
        }
      },
      month: {
        presence: {
          allowEmpty: false,
          message: '^Month has to be selected'
        }
      },
      day: {
        type: 'integer',
        presence: {
          allowEmpty: false,
          message: '^Day has to be selected'
        }
      }
    }
  }
};
